import { CheckboxAttribute } from '../../../../types/CheckboxAttribute';
import { SelectAttribute } from '../../../../types/SelectAttribute';
import { BlockErrorMessage } from '../../../Block/BlockErrorMessage';
import { ButtonBase } from '../../../Button/ButtonBase';
import { CheckBox } from '../../../Form/CheckBox';
import { Select } from '../../../Form/Select';
import { InnerButtonArea } from '../../../Layout/InnerLayout/InnerButtonArea';
import { TableBody } from '../../../Table/TableBody';
import { TableTrFormLabel } from '../../../Table/TableTr/TableTrFromLabel';

import type { InvalidParam } from '../../../../types/InvalidParam';
import type { FC, ChangeEventHandler, FormEventHandler } from 'react';

export type InitialSettingsInvalidParam = InvalidParam & {
  name: 'employmentId' | 'affiliationId' | 'licenseId';
};

export type InitialSettingsInvalidParams = InitialSettingsInvalidParam[];

export type InitialSettingsContentsProps = {
  employmentIdAttributes: SelectAttribute[];
  affiliationIdAttributes: CheckboxAttribute[];
  licenseIdAttributes: CheckboxAttribute[];
  invalidParams?: InitialSettingsInvalidParams;
  disableSubmitButton?: boolean;
  errorMessage?: string;
  eventHandlers?: {
    changeEmploymentId: ChangeEventHandler<HTMLSelectElement>;
    changeAffiliationId: ChangeEventHandler<HTMLInputElement>;
    changeLicenseId: ChangeEventHandler<HTMLInputElement>;
    submit: FormEventHandler<HTMLFormElement>;
  };
};

// eslint-disable-next-line max-lines-per-function
export const InitialSettingsContents: FC<InitialSettingsContentsProps> = ({
  employmentIdAttributes,
  affiliationIdAttributes,
  licenseIdAttributes,
  invalidParams,
  eventHandlers,
  disableSubmitButton,
  errorMessage,
}) => {
  const employmentIdListError = invalidParams?.find(
    (value) => value.name === 'employmentId',
  );

  const affiliationIdError = invalidParams?.find(
    (value) => value.name === 'affiliationId',
  );
  const licenseIdError = invalidParams?.find(
    (value) => value.name === 'licenseId',
  );

  return (
    <form onSubmit={eventHandlers?.submit}>
      <TableBody>
        <TableTrFormLabel
          id="employmentId"
          required={true}
          errorMessage={
            employmentIdListError?.reason ? employmentIdListError?.reason : ''
          }
          title="勤務先種別"
        >
          <Select
            id="employmentId"
            width="default"
            attributes={employmentIdAttributes}
            onChange={eventHandlers?.changeEmploymentId}
          />
        </TableTrFormLabel>

        <TableTrFormLabel
          id="affiliationId"
          required={true}
          errorMessage={
            affiliationIdError?.reason ? affiliationIdError?.reason : ''
          }
          title="所属科"
        >
          <CheckBox
            columns="three"
            attributes={affiliationIdAttributes}
            onChange={eventHandlers?.changeAffiliationId}
          />
        </TableTrFormLabel>

        <TableTrFormLabel
          id="licenseId"
          required={false}
          errorMessage={licenseIdError?.reason ? licenseIdError?.reason : ''}
          title="認定資格 ※5つまで選択可能"
        >
          <CheckBox
            columns="three"
            attributes={licenseIdAttributes}
            onChange={eventHandlers?.changeLicenseId}
          />
        </TableTrFormLabel>
      </TableBody>
      {errorMessage ? (
        <BlockErrorMessage>{errorMessage}</BlockErrorMessage>
      ) : (
        ''
      )}
      <InnerButtonArea>
        <ButtonBase
          color="primary"
          width="extend"
          disable={disableSubmitButton === true}
        >
          設定する
        </ButtonBase>
      </InnerButtonArea>
    </form>
  );
};
